import { AbgSxProps } from '@abg/typings';

export const closeIconStyling: AbgSxProps = {
  width: '16px',
  height: '16px',
};

export const iconWrapperStyling: AbgSxProps = {
  padding: 0,
};

export const dialogStyling = {
  zIndex: '2000',
  '& .MuiDialog-container': {
    justifyContent: {
      sm: 'center',
      xs: 'flex-end',
    },
    alignItems: {
      sm: 'center',
      xs: 'flex-end',
    },
  },
  '& .MuiDialog-paper': {
    width: {
      sm: '432px',
      xs: '100%',
    },
    margin: {
      sm: 2,
      xs: 0,
    },
  },
};

export const dialogTitleStyling = {
  padding: {
    xs: 2,
    sm: 3,
  },
};

export const dialogContentStyling = {
  padding: {
    sm: 3,
    xs: 2,
  },
};
